import React from 'react';

export default function PortalPage() {
  return (
    <div>
      Qualidade - Portal (placeholder).
    </div>
  );
}

